import { render, staticRenderFns } from "./look-up-add-edit.vue?vue&type=template&id=b4703786"
import script from "./look-up-add-edit.vue?vue&type=script&lang=js"
export * from "./look-up-add-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports